import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { environment } from '@environments/environment';
import { initSentry } from 'app/sentry';
import { Environment } from '@nimmsta/ng-commons-lib';
import { AppModule } from './app/app.module';

if (environment.production) {
  enableProdMode();
}

// Initialize Sentry for error tracking and performance monitoring
// This should be done before bootstrapping the Angular application
switch (environment.environment) {
  case Environment.PROD:
  case Environment.STAGING:
  case Environment.DEV:
    initSentry();
    break;
  case Environment.LOCAL:
    // Local development environment, no Sentry initialization
    break;
}

// Bootstrap the Angular application
platformBrowserDynamic()
  .bootstrapModule(AppModule);
